import { AddBox, Delete } from "@mui/icons-material";
import {
  IconButton,
  Typography,
  Grid2 as Grid,
  TextField,
} from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const POCDetailsRowForUpdate = ({ formData, setFormData }) => {
  const handleInputChange = (index, event) => {
    const updatedFields = {
      ...formData,
      pocList: [...formData.pocList],
    };
    updatedFields.pocList[index][event.target.name] = event.target.value;
    setFormData(updatedFields);
  };

  const handleAddForm = () => {
    setFormData({
      ...formData,
      pocList: [
        ...formData.pocList,
        {
          pocDesignation: "",
          pocName: "",
          pocContact: "",
          pocEmail: "",
          pocContactOther: "",
          pocEmailOther: "",
          pocContactOther2: "",
          pocEmailOther2: "",
        },
      ],
    });
  };

  const handleRemoveForm = (index) => {
    const updatedFields = {
      ...formData,
      pocList: [...formData.pocList],
    };
    updatedFields.pocList.splice(index, 1);
    setFormData(updatedFields);
  };

  return (
    <>
      <Typography>
        POC Details
        <IconButton onClick={() => handleAddForm()}>
          <AddBox />
        </IconButton>
      </Typography>{" "}
      <form>
        {formData.pocList.map((field, index) => (
          <Grid container spacing={1} key={index}>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocDesignation"
                name="pocDesignation"
                label="POC Designation"
                variant="outlined"
                value={field.pocDesignation}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
                required
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocName"
                name="pocName"
                label="POC Name"
                variant="outlined"
                value={field.pocName}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
                required
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocContact"
                name="pocContact"
                label="POC Contact"
                variant="outlined"
                value={field.pocContact}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocEmail"
                name="pocEmail"
                label="POC Email"
                variant="outlined"
                value={field.pocEmail}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocContactOther"
                name="pocContactOther"
                label="POC Contact Other"
                variant="outlined"
                value={field.pocContactOther}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocEmailOther"
                name="pocEmailOther"
                label="POC Email Other"
                variant="outlined"
                value={field.pocEmailOther}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocContactOther2"
                name="pocContactOther2"
                label="POC Contact Other 2"
                variant="outlined"
                value={field.pocContactOther2}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 1.4 }}>
              <TextField
                id="pocEmailOther2"
                name="pocEmailOther2"
                label="POC Email Other 2"
                variant="outlined"
                value={field.pocEmailOther2}
                fullWidth
                onChange={(e) => handleInputChange(index, e)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 0.5 }} alignContent="center">
              <FlexBox justifyContent="center">
                <IconButton onClick={() => handleRemoveForm(index)}>
                  <Delete />
                </IconButton>
              </FlexBox>
            </Grid>
          </Grid>
        ))}
      </form>
    </>
  );
};
